import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { DEAL_SECTION_KEYS } from "../deal.constants";

import { underwritingRows, generateCashflowRows } from "./section-deal-disposition-rows";

export class DealDisposition extends Component {
  render() {
    const { data, dealId, isSold, history, ...other } = this.props;
    //   if (!data) return null;
    const cashflowRows = generateCashflowRows(data);

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Disposition Settings",
            key: DEAL_SECTION_KEYS.GENERAL_INFORMATION,
            isExpandable: false,
            isTitleGroup: true,
            buttonLabel: "Edit Details",
            showEditButton: false,
            sections: [
            ]
          },
          {
            title: "Underwriting Assumptions",
            key: DEAL_SECTION_KEYS.GENERAL_INFORMATION,
            isExpandable: true,
            isTitleGroup: false,
            buttonLabel: "Edit Details",
            showEditButton: true,
            onClick: () => history.push(`/deal/${dealId}/edit/${DEAL_SECTION_KEYS.UNDERWRITING_ASSUMPTIONS}`),
            sections: [
              <AccordionSection eventHandlers={this.props.eventHandlers} rows={underwritingRows} data={data} />
            ]
          },
          {
            title: "Cashflow Assumptions",
            key: DEAL_SECTION_KEYS.GENERAL_INFORMATION,
            isExpandable: true,
            isTitleGroup: false,
            buttonLabel: "Edit Details",
            showEditButton: true,
            onClick: () => history.push(`/deal/${dealId}/edit/${DEAL_SECTION_KEYS.CASHFLOW_ASSUMPTIONS}`),
            sections: [
              <AccordionSection eventHandlers={this.props.eventHandlers} rows={cashflowRows} data={data} />
            ]
          }
        ]}
      />
    );
  }
}
